const styles = {
  containerStyle: {
    marginTop: '20%',
    textAlign: 'center',
    width: '100%'
  },
  root: {
    width: '100%',
    maxWidth: 500
  },
  text: {
    fontSize: 100,
    color: 'black',
    textAlign: 'center'
  },
  underText: {
    marginBottom: '2%'
  }
}

export default styles
